import { Button } from '@brighterion/br-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { RulesTypes } from 'Common/enums';
import DeleteTenantGroupOverrideModal from '../DeleteTenantGroupOverrideModal';
import styles from './RemoveOverrideBtn.css';

type Props = {
    id: string;
    showButton?: boolean;
    ruleType: RulesTypes;
};

const RemoveOverrideBtn = ({ showButton, id, ruleType }: Props) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    const removeOverride = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <DeleteTenantGroupOverrideModal
                closeModal={closeModal}
                isOpen={showModal}
                id={id}
                showButton={showButton}
                ruleType={ruleType}
            />
            <div className={styles.container}>
                {showButton && (
                    <Button
                        dataTestId='remove-override-button'
                        variant='contextual-secondary'
                        onClick={handleOnClickEvent(removeOverride)}
                        onKeyDown={handleKeyEvent(removeOverride)}
                    >
                        {t('Remove Override')}
                    </Button>
                )}
            </div>
        </>
    );
};

export default RemoveOverrideBtn;
